import { render, staticRenderFns } from "./Similar.vue?vue&type=template&id=78d16c4c&scoped=true"
import script from "./Similar.vue?vue&type=script&lang=js"
export * from "./Similar.vue?vue&type=script&lang=js"
import style0 from "./Similar.vue?vue&type=style&index=0&id=78d16c4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d16c4c",
  null
  
)

export default component.exports